/* ==========================================================================
   MAISON VINTEJI — v21 · MOTEUR VISUEL 3D  (GSAP + ScrollTrigger)

   Ce fichier ne remplace pas vj-motion.js : il s'ajoute. vj-motion garde le
   parallax des bannières, ses révélations et son tilt sur les blocs maison
   (.vj-stats__item, .vj-grade, .vj-icones__card). Ici on traite ce qu'il ne
   couvre pas — la matière du logo, les cartes produit en volume, la séquence
   d'ouverture et la profondeur au défilement. Chaque élément pris en charge
   est marqué (data-vj3d) et les éléments déjà tenus par vj-motion
   (data-vj-tilt) sont laissés tranquilles : aucun double pilotage.

   Tenue : transform et opacity uniquement, gsap.quickTo pour les
   interpolations au pointeur (une seule écriture par frame), matchMedia pour
   séparer desktop / tactile / mouvement réduit.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.gsap) return;                 /* pas de GSAP : le site reste entier */
  var gsap = window.gsap;
  var ST = window.ScrollTrigger;
  if (ST) gsap.registerPlugin(ST);

  var root = document.documentElement;
  var mm = gsap.matchMedia();

  /* ------------------------------------------------------------------
     FILET — la primitive de sécurité du fichier

     Toute animation qui part d'un état invisible (opacité nulle, mot sous
     sa ligne, image entièrement rognée) doit avoir une garantie d'arrivée.
     Deux pièges vérifiés en test, tous deux réels :

     · Un filet armé au chargement de la page se déclenche AVANT que
       l'animation ne démarre, quand celle-ci attend un déclencheur de
       défilement. Il ne trouve rien à réparer, l'animation part ensuite,
       et plus rien ne la rattrape. Le filet doit donc être armé par
       l'animation, au moment où elle démarre.
     · Un filet qui anime dépend du minuteur — c'est-à-dire de la chose
       même qu'il rattrape. Dans un onglet en arrière-plan le navigateur
       ne distribue plus de frames : GSAP se fige, et le filet avec lui.
       D'où progress(1), qui écrit l'état final sans attendre de frame.
     ------------------------------------------------------------------ */
  function filet(anim, delai) {
    if (!anim) return anim;
    var minuteur = null;
    anim.eventCallback('onStart', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(function () {
        if (anim.progress() < 1) anim.progress(1).kill();
      }, delai || 2600);
    });
    anim.eventCallback('onComplete', function () { clearTimeout(minuteur); });
    return anim;
  }

  /* ------------------------------------------------------------------
     CHIEN DE GARDE — le dernier recours, hors minuteur

     `filet` ci-dessus couvre le cas normal : l'animation démarre puis
     traîne. Il ne couvre PAS le cas où elle ne démarre jamais — et ce cas
     existe : dans un onglet en arrière-plan, le navigateur cesse de
     distribuer des frames, donc ScrollTrigger n'évalue plus les positions,
     donc onEnter ne part pas, donc onStart non plus, donc le filet n'est
     même pas armé. Vérifié en test : dix-huit mots restés sous leur ligne
     et une image entièrement rognée, indéfiniment.

     setTimeout, lui, continue de tomber en arrière-plan (simplement bridé
     à une seconde). Ce garde s'appuie donc uniquement dessus, ne lit que
     des géométries, et remet en place tout ce qui est à la fois VISIBLE à
     l'écran et encore dans son état de départ. Il ne touche à rien de ce
     qui est hors écran : une animation qui n'a pas encore eu lieu doit
     pouvoir avoir lieu.
     ------------------------------------------------------------------ */
  function chienDeGarde() {
    var passages = 0;

    function dansEcran(el) {
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < (window.innerHeight || 0) + 80 && r.width > 0;
    }

    function rattraper() {
      passages++;

      /* mots restés sous leur ligne */
      var mots = document.querySelectorAll('.vj-mot > span');
      Array.prototype.forEach.call(mots, function (m) {
        if (!dansEcran(m.parentNode)) return;
        var ecart = Math.abs(m.getBoundingClientRect().top - m.parentNode.getBoundingClientRect().top);
        if (ecart > 3) { gsap.killTweensOf(m); gsap.set(m, { yPercent: 0 }); }
      });

      /* pièces du catalogue restées transparentes */
      var revs = document.querySelectorAll('[data-vj3d-rev]');
      Array.prototype.forEach.call(revs, function (el) {
        if (!dansEcran(el)) return;
        if (parseFloat(getComputedStyle(el).opacity) < .99) {
          gsap.killTweensOf(el);
          /* jamais clearProps:'transform' ici : la perspective des cartes y
             vit aussi, et l'effacer supprimerait la 3D au lieu de sauver
             l'affichage. On ne rétablit que ce qui a été masqué. */
          gsap.set(el, { opacity: 1, y: 0 });
        }
      });

      /* rideaux restés fermés */
      var rideaux = document.querySelectorAll('[data-vj3d-rideau]');
      Array.prototype.forEach.call(rideaux, function (el) {
        if (!dansEcran(el)) return;
        var cp = getComputedStyle(el).clipPath || '';
        if (cp && cp !== 'none' && !/inset\(0%?\s*0%?\s*0%?/.test(cp)) {
          gsap.killTweensOf(el);
          gsap.set(el, { clearProps: 'clipPath' });
          var im = el.querySelector('img');
          if (im) { gsap.killTweensOf(im); gsap.set(im, { clearProps: 'transform,scale' }); }
        }
      });

      /* le hero, si la séquence n'a jamais démarré */
      if (!root.classList.contains('vj-seq-done') && passages >= 2) {
        root.classList.add('vj-seq-done');
        var seq = document.querySelectorAll('[data-vj-seq]');
        if (seq.length) { gsap.killTweensOf(seq); gsap.set(seq, { clearProps: 'all' }); }
      }

      /* On surveille les trente premières secondes, puis on rend la main :
         passé ce délai, ce qui n'est pas revenu ne reviendra pas d'un
         minuteur, et continuer à sonder coûterait sans rien apporter. */
      if (passages < 8) setTimeout(rattraper, passages < 3 ? 1800 : 4500);
    }

    setTimeout(rattraper, 1800);
    /* au retour sur l'onglet, on vérifie tout de suite plutôt que d'attendre */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { if (ST) ST.refresh(); setTimeout(rattraper, 260); }
    });
  }

  /* ------------------------------------------------------------------
     0. LE GRAIN — généré une fois, réutilisé partout
     Un PNG de bruit chargé depuis le réseau, c'est une requête de plus et
     une taille fixe. On le fabrique en canvas au premier appel et on le
     passe en variable CSS : coût nul au réseau, et il s'adapte.
     ------------------------------------------------------------------ */
  function poserLeGrain() {
    /* même filtre que pour les jointures : un tiroir n'est pas un chapitre */
    var horsFlux = '.offcanvas, .modal, .drawer, .dropdown-menu, .cartDrawer';
    var cibles = [].slice.call(document.querySelectorAll(
      '[class*="color-scheme-2"], [class*="color-scheme-3"], [class*="color-scheme-4"], .vj-grain'
    )).filter(function (el) { return !el.matches(horsFlux) && !el.closest(horsFlux); });
    if (!cibles.length) return;

    var N = 180;
    var c = document.createElement('canvas');
    c.width = c.height = N;
    var ctx = c.getContext('2d');
    var img = ctx.createImageData(N, N);
    var d = img.data;
    for (var i = 0; i < d.length; i += 4) {
      /* bruit monochrome doux : on reste entre 118 et 138 pour que le grain
         se sente sans salir la couleur en dessous. */
      var v = 118 + Math.random() * 20;
      d[i] = d[i + 1] = d[i + 2] = v;
      d[i + 3] = 26;
    }
    ctx.putImageData(img, 0, 0);
    root.style.setProperty('--vj-grain-src', 'url(' + c.toDataURL('image/png') + ')');

    Array.prototype.forEach.call(cibles, function (el) {
      if (el.dataset.vj3dGrain) return;
      el.dataset.vj3dGrain = '1';
      el.classList.add('vj-grain');
    });
  }

  /* ------------------------------------------------------------------
     1. LA FOURRURE — le contour du lettrage du logo, sur les grands titres
     Le filtre est injecté en SVG puis posé sur les titres display. On ne
     l'applique qu'aux titres réellement grands : sous 32 px le déplacement
     ronge les lettres au lieu de les hérisser.
     ------------------------------------------------------------------ */
  /* Le filtre de turbulence a été retiré (v23).
     Il partait d'une lecture fausse du logo : une turbulence hérisse un
     contour, alors que les lettres du logo ne sont pas hérissées — elles sont
     VOLUMINEUSES. Rondes, épaisses, éclairées par le haut, posées sur un
     fond. Reproduire du poil quand il fallait reproduire du volume donnait
     un texte rongé, sans rapport avec la marque. On applique donc du relief :
     une extrusion sur cinq strates de l'échelle brune, plus un modelé en
     dégradé sur le titre d'ouverture. Tout est en CSS (vj-relief.css), donc
     sans filtre à repeindre à chaque frame — c'est aussi bien plus léger. */
  /* poserLeRelief() supprimée : le relief est entièrement porté par le CSS,
     appliqué par les schémas de couleur eux-mêmes. Aucun JS n'est nécessaire
     pour poser une ombre, et une classe posée en JS arrive de toute façon
     après le premier rendu. */

  /* Le verre liquide sur le header : c'est la surface qui passe au-dessus de
     tout le reste, donc la seule où l'épaisseur se lit vraiment. */
  function poserLeVerre() {
    var barre = document.querySelector('.header-wrapper') ||
                document.querySelector('.section-header');
    if (barre && !barre.dataset.vj3dVerre) {
      barre.dataset.vj3dVerre = '1';
      barre.classList.add('vj-verre');
    }
    /* Les tiroirs ne reçoivent plus le verre. Le gain visuel y est faible —
       ils sont déjà opaques et posés au-dessus de tout — et le risque est
       élevé : toute classe qui les touche peut les faire retomber dans le
       flux et ouvrir un trou dans la page. Le verre reste sur le header,
       où il se voit vraiment. */
  }

  /* ------------------------------------------------------------------
     2. LES CARTES EN VOLUME
     Trois plans : le cadre s'incline, l'image avance, l'ombre se décale à
     l'opposé de l'inclinaison. C'est le décalage de l'ombre qui vend le
     volume — une ombre centrée reste une vignette.
     ------------------------------------------------------------------ */
  function monterLesCartes() {
    /* Les cartes du catalogue sont TRANSPARENTES (card_background_opacity: 0
       dans le preset). Toute ombre posée en élément derrière elles est donc
       visible à travers — c'est ce qui produisait la tache brune. Et comme la
       carte crée son propre contexte d'empilement (transform + preserve-3d),
       un z-index négatif ne peut de toute façon jamais passer dessous.

       L'ombre est donc rendue à qui la projette : la PHOTO. `.card--image`
       est opaque, c'est l'objet physique de la carte, et une ombre y est une
       propriété (box-shadow), plus un élément de plus. */
    var cartes = document.querySelectorAll('.card-main');
    Array.prototype.forEach.call(cartes, function (carte) {
      if (carte.dataset.vj3d || carte.dataset.vjTilt) return;
      carte.dataset.vj3d = '1';
      carte.classList.add('vj-card3d');

      var media = carte.querySelector('.card--image');
      if (!media) return;
      media.classList.add('vj-card3d__media');
      /* L'ombre ne va PAS sur `.card--image` : ce <a> calcule en display:inline
         selon les gabarits, et une ombre sur une boîte inline ne se dessine
         pas. Elle va sur le cadre carré `.card__inner`, qui porte le ratio et
         a donc toujours des dimensions réelles. C'est aussi le bon objet :
         c'est lui, le cadre de la photo. */
      var cadre = carte.querySelector('.card__inner') || media;
      var img = media.querySelector('img');

      /* VJ-CORR-D125-DEBUT — 3 septembre 2026 — LE SURVOL CESSE DE ROGNER
         Rachid, capture a l'appui sur « LA SELECTION DU MOMENT » : « LORSQU'ON
         PASSE LA SOURIS SUR UN PRODUIT LA FICHE SE SURELEVE ET LE PRODUIT EST
         ROGNE ».
         MESURE. Trois effets se cumulaient ici, tous les trois coupables :
           1. `rx`/`ry` inclinaient la carte jusqu'a 26° (MAX 13, double) avec
              une perspective de 900. Une carte inclinee a 26° dans un
              `.card--image { overflow: hidden }` voit ses coins passer sous
              le rectangle de rognage, qui lui reste plat : ce sont les angles
              du produit qui sautent.
           2. `is(1.07)` agrandissait l'image DANS ce meme cadre rogneur :
              7 % de plus pour une boite inchangee, soit 14,4 px de produit
              coupes de chaque cote sur une vignette de 411,6. Aujourd'hui
              l'effet ne se voit pas parce qu'AUCUN produit n'a de photo
              (0 sur 41, defaut admin n°1) et que `querySelector('img')`
              rend null sur un SVG de remplacement. Il se verrait le jour ou
              les photos arrivent — c'est-a-dire au pire moment.
           3. `ty(-16)` levait la carte de 16 px. Releve sur le carrousel :
              `.card--image` passe de y 219 a 202,8 alors que le cadre de la
              carte, lui, ne bouge pas.
         On garde une levee, parce qu'une carte cliquable doit repondre — mais
         une levee franche et PLATE, de 6 px, sans rotation et sans zoom. Rien
         ne peut plus etre coupe : plus rien ne sort de son cadre.
         Rollback : retablir le bloc d'origine entre les deux marqueurs. */
      var ty = gsap.quickTo(carte, 'y', { duration: .45, ease: 'power3' });

      carte.addEventListener('pointerenter', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        ty(-6);
        cadre.style.setProperty('--vj-vol-y', '22px');
      });

      carte.addEventListener('pointerleave', function () {
        ty(0);
        cadre.style.setProperty('--vj-vol-y', '10px');
      });
      /* VJ-CORR-D125-FIN */
    });
  }

  /* ------------------------------------------------------------------
     3. LA SÉQUENCE D'OUVERTURE
     Un moment, pas une collection d'effets : le logo se pose, le cartel
     arrive, le titre monte ligne par ligne, le bouton apparaît en dernier.
     Jouée une fois par session — la rejouer à chaque navigation devient
     vite une gêne pour qui parcourt le catalogue.
     ------------------------------------------------------------------ */
  function ouvrir() {
    var accueil = document.body.classList.contains('template-index') ||
                  document.body.classList.contains('active-template-index') ||
                  /^\/($|\?)/.test(location.pathname);
    if (!accueil) { root.classList.add('vj-seq-done'); return; }

    var dejaVue = false;
    try { dejaVue = sessionStorage.getItem('vj-seq') === '1'; } catch (e) {}
    if (dejaVue) { root.classList.add('vj-seq-done'); return; }

    /* Aucun sélecteur ne dépend de <main> : selon le gabarit le hero vit
       dans la section slideshow, dans une bannière, ou directement dans le
       corps. Chaque pièce est cherchée du plus précis au plus général. */
    var q = function (sel) { return document.querySelector(sel); };
    /* Le logo du header est déjà piloté par vj-motion.js (initCondense), qui
       lui écrit un translateX au scroll pour l'amener au centre. Le lui
       tweener ici, puis faire clearProps:'all' à la fin, effaçait ce
       translateX et le will-change : le glissement mourait. On anime donc le
       logo SANS jamais toucher à sa transformation, et on ne nettoie que ce
       qu'on a posé. */
    var logo   = q('header .wdt-logo-container img, header .header-title img, header img');
    var cartel = q('.slideshow_swiper .subheading, .banner .subheading, .slider-subheading, .subheading');
    /* VJ-CORR-D615 — le h1 de l'accueil est maintenant le SUR-TITRE : la séquence anime toujours le SLOGAN,
       repéré par sa classe ; querySelector rendant le premier élément dans l'ordre du document (et non
       la première règle de la liste), le repli exclut le sur-titre. */
    var titre  = q('.slideshow_swiper .vj-titre-diapo-1') || q('.slideshow_swiper h1:not(.vj-surtitre-h1), .banner__heading, .image-banner h1, h1:not(.vj-surtitre-h1)');
    var bouton = q('.slideshow_swiper .btn, .banner__buttons .btn, .btn-primary, .btn');

    var pieces = [logo, cartel, titre, bouton].filter(Boolean);
    if (!pieces.length) { root.classList.add('vj-seq-done'); return; }
    pieces.forEach(function (el) { el.setAttribute('data-vj-seq', ''); });
    root.classList.add('vj-seq');

    var tl = gsap.timeline({ defaults: { ease: 'expo.out' } });

    if (logo)   tl.fromTo(logo,   { opacity: 0, filter: 'blur(14px)' },
                                  { opacity: 1, filter: 'blur(0px)', duration: 1.1 });
    if (cartel) tl.fromTo(cartel, { opacity: 0, y: 14, letterSpacing: '.6em' },
                                  { opacity: 1, y: 0, letterSpacing: '.30em', duration: .9 }, '-=.55');
    if (titre)  tl.fromTo(titre,  { opacity: 0, y: 46, rotationX: -34, transformOrigin: '50% 100%' },
                                  { opacity: 1, y: 0, rotationX: 0, duration: 1.15 }, '-=.6');
    if (bouton) tl.fromTo(bouton, { opacity: 0, y: 18, scale: .94 },
                                  { opacity: 1, y: 0, scale: 1, duration: .7 }, '-=.7');

    /* La séquence part elle aussi d'un état invisible : même garantie.
       Elle démarre immédiatement, donc son filet s'arme tout de suite. */
    filet(tl, 5000);
    setTimeout(function () { root.classList.add('vj-seq-done'); }, 5200);
    tl.eventCallback('onComplete', function () {
      root.classList.add('vj-seq-done');
      /* clearProps ciblé : 'all' effaçait aussi le transform du logo, propriété
         de vj-motion. On ne rend que ce qu'on a emprunté. */
      pieces.forEach(function (el) { gsap.set(el, { clearProps: 'opacity,filter,y,rotationX,scale,letterSpacing' }); });
      try { sessionStorage.setItem('vj-seq', '1'); } catch (e) {}
      if (ST) ST.refresh();
    });

    return tl;
  }

  /* ------------------------------------------------------------------
     4. LE DÉFILEMENT
     Révélations groupées (une seule passe par lot, pas un observateur par
     carte) et profondeur sur les chapitres à fond plein.
     ------------------------------------------------------------------ */
  function auDefilement() {
    if (!ST) return;

    /* 4a. RÉVÉLATIONS GROUPÉES

       Principe non négociable : une fiche produit ne doit jamais dépendre
       d'une animation pour être visible. Si le script cale, si le minuteur
       est bridé (onglet en arrière-plan), si un déclencheur se pose sur une
       hauteur fausse parce qu'une image a chargé trop tard — le client doit
       quand même voir la marchandise. Trois garde-fous, dans cet ordre :

       1. On ne masque QUE ce qui est hors écran au démarrage. Révéler un
          élément déjà visible n'apporte rien de toute façon, et c'est le cas
          le plus dangereux : c'est celui du haut de page.
       2. once: true — une fois révélé, l'élément ne peut plus être re-caché.
       3. Un filet à 3 s qui rend tout visible quoi qu'il arrive.
    */
    /* On révèle le CONTENEUR de la carte, jamais la carte.
       Révéler `.card-main` était l'erreur centrale : le tween de révélation
       porte `overwrite`, qui tue tous les autres tweens de la même cible —
       donc les tweens d'inclinaison montés juste après. Résultat, la 3D
       mourait sur toutes les cartes situées sous la ligne de flottaison,
       c'est-à-dire sur tout le catalogue. En visant le parent, révélation et
       inclinaison n'ont plus aucune cible commune. */
    var candidats = document.querySelectorAll(
      '.card-wrapper:not([data-vj3d-rev]), li.product-loop:not([data-vj3d-rev]), ' +
      '.collection-list .content-item, .featured-collection .card-wrapper'
    );
    var lots = [];
    Array.prototype.forEach.call(candidats, function (el) {
      el.dataset.vj3dRev = '1';
      var r = el.getBoundingClientRect();
      /* déjà à l'écran (ou au-dessus) : on n'y touche pas */
      if (r.top < window.innerHeight * 0.95) return;
      lots.push(el);
    });

    if (lots.length) {
      gsap.set(lots, { opacity: 0, y: 34 });

      var reveler = function (groupe) {
        filet(gsap.to(groupe, {
          opacity: 1, y: 0, duration: .85, ease: 'power3.out',
          stagger: .07, overwrite: 'auto'
        }), 2600);
      };

      ST.batch(lots, {
        start: 'top 88%',
        once: true,
        batchMax: 6,
        interval: .08,
        onEnter: reveler
      });

      /* Le filet, en écriture INSTANTANÉE (gsap.set, pas gsap.to).
         Un filet qui anime dépendrait du minuteur — c'est-à-dire de la chose
         même qu'il est censé rattraper. Vérifié : dans un onglet en
         arrière-plan le navigateur ne distribue plus de frames, GSAP
         n'avance donc plus, et un filet animé rampait exactement comme la
         révélation. gsap.set écrit le style tout de suite, sans frame. */
      setTimeout(function () {
        var restants = lots.filter(function (el) {
          return parseFloat(getComputedStyle(el).opacity) < .99;
        });
        if (restants.length) {
          /* clearProps:'transform' effaçait la perspective posée sur la carte.
             On ne remet que ce qu'on avait pris : l'opacité et le décalage. */
          gsap.killTweensOf(restants);
          gsap.set(restants, { opacity: 1, y: 0 });
        }
      }, 3000);
    }

    /* 4b. profondeur : sur un chapitre à fond plein, le contenu dérive un
       peu plus vite que le fond. Le fond ne bouge pas, donc aucun bord ne
       peut se découvrir — c'est le contenu qui crée les plans. */
    var chapitres = document.querySelectorAll(
      '[class*="color-scheme-2"] .page-width, [class*="color-scheme-3"] .page-width, ' +
      '[class*="color-scheme-4"] .page-width, .vj-hist__inner, .vj-intro__inner'
    );
    Array.prototype.forEach.call(chapitres, function (el) {
      if (el.dataset.vj3dDepth) return;
      el.dataset.vj3dDepth = '1';
      el.classList.add('vj-depth');
      gsap.fromTo(el, { y: 28 }, {
        y: -28, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: .6 }
      });
    });
  }


  /* ==================================================================
     v22 — LE RESTE DU SITE
     ================================================================== */

  /* ------------------------------------------------------------------
     6. LES TITRES MOT À MOT
     On n'enveloppe que les titres faits d'un seul nœud de texte : dès
     qu'un titre contient un lien ou une balise, le découper casserait
     sa structure. Le texte reste intact dans le DOM, donc les lecteurs
     d'écran le lisent exactement pareil.
     ------------------------------------------------------------------ */
  function decouperLesTitres() {
    if (!ST) return;
    var titres = document.querySelectorAll(
      'h2:not([data-vj3d-mot]), .vj-hist__titre, .content-showcase h2, .featured-collection h2'
    );
    Array.prototype.forEach.call(titres, function (t) {
      if (t.dataset.vj3dMot) return;
      /* VJ-CORR-D589 — 5 octobre 2026 : le bandeau de consentement et sa fenêtre
         (`#shopify-pc__…`, injectés par Shopify) ne sont pas des sections qui
         « entrent » : leur titre n'est ni découpé ni levé au défilement (relevé :
         « Consentement aux cookies » en trois .vj-mot à 108 % sous la ligne). */
      if (t.closest && t.closest('[id^="shopify-pc__"]')) { t.dataset.vj3dMot = '0'; return; }
      /* un seul nœud, et du texte : sinon on passe */
      if (t.childNodes.length !== 1 || t.childNodes[0].nodeType !== 3) return;
      var texte = t.textContent.trim();
      if (!texte || texte.length > 90) return;
      t.dataset.vj3dMot = '1';

      var mots = texte.split(/\s+/);
      t.textContent = '';
      var interieurs = [];
      mots.forEach(function (mot, i) {
        var enveloppe = document.createElement('span');
        enveloppe.className = 'vj-mot';
        var interieur = document.createElement('span');
        interieur.textContent = mot;
        enveloppe.appendChild(interieur);
        t.appendChild(enveloppe);
        interieurs.push(interieur);
        if (i < mots.length - 1) t.appendChild(document.createTextNode(' '));
      });

      var lever = function () {
        for (var k = 0; k < interieurs.length; k++) {
          interieurs[k].parentNode.classList.add('vj-mot--pose');
        }
      };
      var tw = gsap.fromTo(interieurs, { yPercent: 108 }, {
        yPercent: 0, duration: .9, ease: 'expo.out', stagger: .055,
        onComplete: lever,
        scrollTrigger: { trigger: t, start: 'top 88%', once: true }
      });
      filet(tw, 2600);
      /* le filet peut terminer le tween sans passer par onComplete */
      setTimeout(lever, 4200);
    });
  }

  /* ------------------------------------------------------------------
     7. LE RIDEAU SUR LES MÉDIAS
     Le cadre se découvre par le bas pendant que l'image se dézoome :
     deux vitesses, donc deux plans. clip-path est composité, contrairement
     à une animation de hauteur qui relancerait la mise en page.
     ------------------------------------------------------------------ */
  function poserLesRideaux() {
    if (!ST) return;
    var medias = document.querySelectorAll(
      '.image-with-text__media, .content-showcase .image-block, ' +
      '.grid-banner .banner-media, .collection-list .content-image'
    );
    Array.prototype.forEach.call(medias, function (m) {
      if (m.dataset.vj3dRideau || m.dataset.vjParallax) return;
      m.dataset.vj3dRideau = '1';
      m.classList.add('vj-rideau');
      var img = m.querySelector('img');
      var tl = gsap.timeline({ scrollTrigger: { trigger: m, start: 'top 86%', once: true } });
      tl.fromTo(m, { clipPath: 'inset(0% 0% 100% 0%)' },
                   { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.1, ease: 'expo.out' });
      if (img) tl.fromTo(img, { scale: 1.22 }, { scale: 1, duration: 1.3, ease: 'expo.out' }, 0);
      filet(tl, 3000);
    });
  }

  /* ------------------------------------------------------------------
     8. LA BARRE DE PROGRESSION
     Pilotée par un seul ScrollTrigger en scrub, pas par un écouteur de
     scroll : ScrollTrigger lit déjà la position une fois par frame, en
     ajouter un second la ferait lire deux fois.
     ------------------------------------------------------------------ */
  function barreDeProgression() {
    if (!ST || document.querySelector('.vj-progres')) return;
    var barre = document.createElement('div');
    barre.className = 'vj-progres';
    barre.setAttribute('aria-hidden', 'true');
    document.body.appendChild(barre);
    gsap.to(barre, {
      scaleX: 1, ease: 'none',
      scrollTrigger: { start: 0, end: 'max', scrub: .3 }
    });
  }

  /* ------------------------------------------------------------------
     9. LE BANDEAU DÉFILANT SUIT LA MAIN
     Le bandeau accélère avec la vitesse de défilement et repart en sens
     inverse quand on remonte. C'est ce lien entre le geste et l'image qui
     rend une page « vivante » — bien plus qu'une animation en boucle.
     ------------------------------------------------------------------ */
  function bandeauVivant() {
    if (!ST) return;
    var bandes = document.querySelectorAll('.marquee-section .marquee, .vj-marquee, [class*="marquee"] > *');
    Array.prototype.forEach.call(bandes, function (b) {
      if (b.dataset.vj3dMarq) return;
      b.dataset.vj3dMarq = '1';
      var vitesse = gsap.quickTo(b, 'timeScale', { duration: .5, ease: 'power2' });
      ST.create({
        start: 0, end: 'max',
        onUpdate: function (self) {
          var v = Math.min(Math.abs(self.getVelocity()) / 900, 3);
          if (b._gsapTween) b._gsapTween.timeScale(1 + v);
          else b.style.setProperty('--vj-marquee-boost', (1 + v).toFixed(2));
        }
      });
      void vitesse;
    });
  }

  /* ------------------------------------------------------------------
     10. LE TIROIR DU PANIER
     Les lignes arrivent l'une après l'autre à l'ouverture. Court : au-delà
     de trois articles, un échelonnement devient une attente.
     ------------------------------------------------------------------ */
  function tiroirVivant() {
    document.addEventListener('click', function (e) {
      var d = e.target.closest('[data-bs-toggle="offcanvas"], .header__icon--cart, .cart-icon');
      if (!d) return;
      setTimeout(function () {
        var lignes = document.querySelectorAll(
          '.offcanvas.show .cart-item, .cart-drawer .cart-item, .offcanvas.show .cart__item'
        );
        if (!lignes.length) return;
        gsap.fromTo(lignes, { opacity: 0, x: 26 },
          { opacity: 1, x: 0, duration: .5, ease: 'power3.out', stagger: .06, overwrite: true });
      }, 90);
    }, true);
  }

  /* ------------------------------------------------------------------
     11. LA JOINTURE DES CHAPITRES
     Deux fonds pleins qui se touchent font un trait horizontal dur. On
     lit la couleur réelle de la section précédente et on la fond sur
     48 px. Aucune couleur nouvelle : c'est la sienne, en dégradé.
     ------------------------------------------------------------------ */
  function fondreLesChapitres() {
    /* Exclusion explicite des surcouches. Les tiroirs, fenêtres modales et
       menus portent eux aussi une classe `color-scheme` : sans ce filtre, ils
       étaient traités comme des chapitres de page, sortis de leur
       positionnement et réinjectés dans le flux. */
    var horsFlux = '.offcanvas, .modal, .drawer, .dropdown-menu, .cartDrawer, [data-bs-backdrop]';
    var sections = [].slice.call(document.querySelectorAll(
      '.shopify-section > section, .shopify-section > div[class*="color-scheme"], ' +
      'section[class*="color-scheme"]'
    )).filter(function (el) {
      return !el.matches(horsFlux) && !el.closest(horsFlux);
    });
    sections.forEach(function (sec, i) {
      if (sec.dataset.vj3dJoint || i === 0) return;
      var precedent = sections[i - 1];
      if (!precedent) return;
      var a = getComputedStyle(precedent).backgroundColor;
      var b = getComputedStyle(sec).backgroundColor;
      if (!a || !b || a === b) return;
      if (a === 'rgba(0, 0, 0, 0)' || b === 'rgba(0, 0, 0, 0)') return;
      sec.dataset.vj3dJoint = '1';
      sec.classList.add('vj-jointure');
      sec.style.setProperty('--vj-jointure-vers', b);
    });
  }

  /* ------------------------------------------------------------------
     5. MISE EN ROUTE
     matchMedia sépare les trois cas. GSAP nettoie tout seul ce qui a été
     créé dans un contexte quand la condition cesse d'être vraie — d'où
     l'absence de code de démontage manuel.
     ------------------------------------------------------------------ */
  function demarrer() {
    poserLeGrain();
    fondreLesChapitres();
    poserLeVerre();

    mm.add({
      complet: '(prefers-reduced-motion: no-preference) and (hover: hover) and (pointer: fine)',
      tactile: '(prefers-reduced-motion: no-preference) and (hover: none)',
      sobre:   '(prefers-reduced-motion: reduce)'
    }, function (ctx) {
      var c = ctx.conditions;

      if (c.sobre) {
        /* Rien ne bouge. Le grain reste : c'est de la matière, pas du
           mouvement, et il ne gêne personne. */
        root.classList.add('vj-seq-done');
        return;
      }

      ouvrir();
      auDefilement();
      decouperLesTitres();
      poserLesRideaux();
      barreDeProgression();
      bandeauVivant();
      tiroirVivant();
      chienDeGarde();

      if (c.complet) {
        monterLesCartes();
      }
      /* En tactile : pas de fourrure (le filtre SVG coûte trop cher sur les
         GPU mobiles au moment du scroll) et pas d'inclinaison au pointeur.
         Les révélations et la profondeur, elles, restent : c'est ce qui
         rend le site vivant au doigt. */
    });

    /* Les images arrivent après le premier calcul : sans ce recalcul, les
       déclencheurs sont posés sur des hauteurs fausses et les révélations
       partent trop tôt. */
    if (ST) {
      window.addEventListener('load', function () { ST.refresh(); });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { ST.refresh(); });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  /* VJ-CORR-D374 — les cartes d'une page de catalogue chargée en AJAX
     (wdt-filter.js) n'étaient jamais montées : même levée qu'à la page 1. */
  window.addEventListener('vj:grille-remplacee', function () {
    if (window.matchMedia('(prefers-reduced-motion: no-preference) and (pointer: fine)').matches) {
      monterLesCartes();
    }
    if (ST) ST.refresh();
  });

  /* Shopify réinjecte le contenu d'une section quand on l'édite dans le
     personnalisateur : sans ça, l'aperçu perd tous les effets dès la
     première modification. */
  document.addEventListener('shopify:section:load', function () {
    poserLeGrain();
    fondreLesChapitres();
    poserLeVerre();
    decouperLesTitres();
    poserLesRideaux();
    poserLeVerre();
    if (window.matchMedia('(prefers-reduced-motion: no-preference) and (pointer: fine)').matches) {
      monterLesCartes();
    }
    if (ST) ST.refresh();
  });
})();
